export default __webpack_public_path__ + "static/media/Ev_pfp.ab876fef.png";